export interface CsvColumnsExportDefinition<T> {
  columnTitle: string;
  numberFormatting?: Intl.NumberFormatOptions;
  getValue: (value: T) => number | string | null | undefined | Date;
}
